import { render } from "./NotFound.vue?vue&type=template&id=7bd8d00d&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=7bd8d00d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gigae\\projects\\ecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd8d00d"]])

export default __exports__